import { render, staticRenderFns } from "./ContestGame.vue?vue&type=template&id=031f28f4&"
import script from "./ContestGame.vue?vue&type=script&lang=js&"
export * from "./ContestGame.vue?vue&type=script&lang=js&"
import style0 from "./ContestGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports